import { Box, Group } from "@mantine/core";
import { useCheckPermission } from "../../../../hooks/useCheckPermission";
import ExportForMonitoringReports from "./ExportForMonitoringReports";

const ForMonitoringHeader = () => {
  const exportPermission = useCheckPermission("DOWNLOAD_REPORT");

  if (!exportPermission) return null;

  return (
    <Box bg="gray.1" p="md">
      <Group>
        <ExportForMonitoringReports />
      </Group>
    </Box>
  );
};

export default ForMonitoringHeader;
